import { notifications } from "@mantine/notifications"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import type { MaterialType } from "@tfg/db"
import { AxiosError } from "axios"

import { materialTypeUpdateValidationType } from "@tfg/types/schemas/admin"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useCreateMaterialTypeMutation = (
  options?: UseMutationOptions<
    MaterialType,
    unknown,
    materialTypeUpdateValidationType
  >
) =>
  useMutation<MaterialType, AxiosError, materialTypeUpdateValidationType>({
    ...options,
    mutationFn: async (materialType: materialTypeUpdateValidationType) => {
      const res = await httpClient.post<MaterialType>(
        "/admin/materialTypes",
        materialType
      )
      return res.data
    },
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      await queryClient.invalidateQueries(["materialTypes"])
      notifications.show({
        title: "Added",
        message: `Successfully added material type ${variables.key}`,
        color: "green",
      })
    },
  })
